import React from "react";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import {
  deleteDVIRQuestion,
  resetShowDeleteQuestionConfirmationModal,
} from "../../dvirSlice";
import "./DeleteQuestionModal.scss";

export function DeleteQuestionModal() {
  const dispatch = useAppDispatch();
  const questionToDelete = useAppSelector(
    (state) => state.dvir.showDeleteQuestionConfirmationModal
  );
  const deleteAPI = useAppSelector((state) => state.dvir.deleteDVIRQuestion);

  const handleConfirmDelete = () => {
    if (questionToDelete) {
      dispatch(deleteDVIRQuestion(questionToDelete.id));
    }
  };

  const handleClose = () => {
    dispatch(resetShowDeleteQuestionConfirmationModal());
  };

  if (!questionToDelete) return null;

  const isUsedInTemplates = questionToDelete.templateCount > 0;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div
        className="delete-question-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>
            {isUsedInTemplates ? "Cannot Delete Question" : "Delete Question"}
          </h3>
          <button className="close-button" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {isUsedInTemplates ? (
            <div className="usage-warning">
              <div className="warning-icon">⚠️</div>
              <div className="warning-content">
                <p className="warning-title">
                  This question is currently being used
                </p>
                <p className="warning-message">
                  This question is used in{" "}
                  <strong>
                    {questionToDelete.templateCount} template
                    {questionToDelete.templateCount === 1 ? "" : "s"}
                  </strong>{" "}
                  and cannot be deleted.
                </p>
                <p className="warning-suggestion">
                  To delete this question, you must first remove it from all
                  templates where it's being used.
                </p>
              </div>
            </div>
          ) : (
            <div className="delete-confirmation">
              <div className="danger-icon">🗑️</div>
              <div className="confirmation-content">
                <p className="confirmation-title">
                  Are you sure you want to delete this question?
                </p>
                <div className="question-preview">
                  <div className="question-text">
                    "{questionToDelete.questionText}"
                  </div>
                  <div className="question-type">
                    Type: {questionToDelete.questionType}
                  </div>
                </div>
                <p className="confirmation-warning">
                  This action cannot be undone. The question will be permanently
                  removed from the system.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={deleteAPI.loading}
          >
            {isUsedInTemplates ? "Close" : "Cancel"}
          </button>
          {!isUsedInTemplates && (
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleConfirmDelete}
              disabled={deleteAPI.loading}
            >
              {deleteAPI.loading ? "Deleting..." : "Delete Question"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
